import { When } from 'react-if';
import { NodeTypeWire } from '../../../external/server/node-type.wire';
import { NodeStore } from '../../core/node/node.store';
import { MegaBoard } from './mega/mega-board';

export function UnifiedBoard({ boardId }: { boardId: string }) {
  const board = NodeStore.useItem(boardId);

  return (
    <When condition={board.type === NodeTypeWire.mega}>
      <MegaBoard boardId={boardId} />
    </When>
  );
}
